/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';
import CSSModules from 'react-css-modules';
import styles from './ImageInfo.css';

class ImageInfo extends Component {
  static propTypes = {
    labelText: PropTypes.string,
    badgeText: PropTypes.string,
    href: PropTypes.string,
  };

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(...args) {
    super(...args);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    if (this.props.href) {
      location.assign(this.props.href);
    }
  }

  render() {
    const isClickable = Boolean(this.props.href);
    const styleName = classnames('info', {
      '-clickable': isClickable,
    });

    return (
      <div styleName={styleName} onClick={this.handleClick}>
        {
          this.props.badgeText ?
            <span styleName="badge">{this.props.badgeText}</span> :
            null
        }

        {this.props.labelText}
      </div>
    );
  }
}

export default CSSModules(ImageInfo, styles, {
  errorWhenNotFound: false,
  allowMultiple: true,
});



// WEBPACK FOOTER //
// ./application/js/components/ImageInfo.js